"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

var _merge = _interopRequireDefault(require("element-ui/lib/utils/merge"));

// 扩展在 form 标签上添加 onsubmit= " return false" 解决 enter 键 触发页面自动刷新问题
var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('form', {
    staticClass: "el-form",
    "class": [_vm.labelPosition ? 'el-form--label-' + _vm.labelPosition : '', {
      'el-form--inline': _vm.inline
    }],
    attrs: {
      "onsubmit": " return false;"
    }
  }, [_vm._t("default", null, {})], 2);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElForm',
  componentName: 'ElForm',
  provide: function provide() {
    return {
      elForm: this
    };
  },
  props: {
    model: Object,
    rules: Object,
    labelPosition: String,
    width: String,
    labelWidth: String,
    labelSuffix: {
      type: String,
      // 扩展 修改默认的后缀
      "default": '：'
    },
    inline: Boolean,
    inlineMessage: Boolean,
    statusIcon: Boolean,
    showMessage: {
      type: Boolean,
      "default": true
    },
    size: String,
    disabled: Boolean,
    validateOnRuleChange: {
      type: Boolean,
      "default": true
    }
  },
  watch: {
    rules: function rules() {
      if (this.validateOnRuleChange) {
        this.validate(function () {});
      }
    }
  },
  data: function data() {
    return {
      fields: []
    };
  },
  created: function created() {
    var _this = this;

    this.$on('el.form.addField', function (field) {
      if (field) {
        _this.fields.push(field);
      }
    });
    /* istanbul ignore next */

    this.$on('el.form.removeField', function (field) {
      if (field.prop) {
        _this.fields.splice(_this.fields.indexOf(field), 1);
      }
    });
  },
  methods: {
    resetFields: function resetFields() {
      if (!this.model) {
        false && console.warn('[Element Warn][Form]model is required for resetFields to work.');
        return;
      }

      this.fields.forEach(function (field) {
        field.resetField();
      });
    },
    clearValidate: function clearValidate() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      // eslint-disable-next-line no-unused-vars
      var fields = props.length ? this.fields.filter(function (field) {
        return props.indexOf(field.prop) > -1;
      }) : this.fields;
      this.fields.forEach(function (field) {
        field.clearValidate();
      });
    },
    validate: function validate(callback) {
      var _this2 = this;

      if (!this.model) {
        console.warn('[Element Warn][Form]model is required for validate to work!');
        return;
      }

      var promise; // if no callback, return promise

      if (typeof callback !== 'function' && window.Promise) {
        promise = new window.Promise(function (resolve, reject) {
          callback = function callback(valid) {
            valid ? resolve(valid) : reject(valid);
          };
        });
      }

      var valid = true;
      var count = 0; // 如果需要验证的fields为空，调用验证时立刻返回callback

      if (this.fields.length === 0 && callback) {
        callback(true);
      }

      var invalidFields = {};
      var errorFields = [];
      this.fields.forEach(function (field) {
        var formItem = field;
        field.validate('', function (message, field) {
          if (message) {
            valid = false;
            errorFields.push(formItem);
          }

          invalidFields = (0, _merge["default"])({}, invalidFields, field);

          if (typeof callback === 'function' && ++count === _this2.fields.length) {
            callback(valid, invalidFields, errorFields);
          }
        });
      });

      if (promise) {
        return promise;
      }
    },
    validateField: function validateField(prop, cb) {
      var field = this.fields.filter(function (field) {
        return field.prop === prop;
      })[0];

      if (!field) {
        throw new Error('must call validateField with valid prop string!');
      }

      field.validate('', cb);
    }
  }
};
exports["default"] = _default;